import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { queryKeys } from '../lib/queryClient';

/**
 * Hook to fetch today's sessions for the Recent Sessions screen
 * This replaces the manual useEffect + axios pattern in RecentSessionsScreen
 */
function useRecentSessions({ token, enabled = true }) {
  const fetchRecentSessions = async () => {
    const { data } = await api.get('/sessions/today', {
      headers: {
        Authorization: token,
      },
    });
    return data;
  };

  const { data, error, isLoading, isPending, isFetching, isError, refetch } =
    useQuery({
      queryKey: queryKeys.sessions.today(),
      queryFn: fetchRecentSessions,
      enabled: !!token && enabled,
      // Refetch every 1 minute to keep data fresh
      refetchInterval: 60000,
      // Keep previous data while refetching
      placeholderData: (previousData) => previousData,
      staleTime: 1000 * 30, // Consider stale after 30 seconds
    });

  return {
    data,
    isLoading: isLoading || isPending,
    isFetching,
    isError,
    error,
    refetch,
  };
}

export default useRecentSessions;
